import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8 pt-14 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading text-accent-400 whitespace-nowrap">
                韩漫漫画
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              海量正版韩漫漫画在线阅读平台，提供多元分类漫画资源，访问便捷安全，畅享高品质阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              <a href="/category/all" className="no-underline text-background-100 hover:text-accent-400 transition-colors">漫画分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.filter(c => c.slug !== 'all').map(cat => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">用户协议</a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">隐私政策</a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">帮助中心</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-accent-400"></i>
                contact@manhuakr.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-accent-400"></i>
                400-888-0000
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-accent-400"></i>
                北京市朝阳区
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 韩漫漫画 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-accent-500 hover:text-background-50 transition-colors" rel="nofollow" aria-label="微博">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-accent-500 hover:text-background-50 transition-colors" rel="nofollow" aria-label="微信">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-accent-500 hover:text-background-50 transition-colors" rel="nofollow" aria-label="B站">
              <i className="ri-bilibili-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}